import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

// Geometry contract: the legacy AlertBar rendered position:fixed, full-width
// and exactly 40px tall, and src/redux/selectors/css.selectors.ts offsets every
// other fixed layout element (TopBar, Sidenav, …) by 40px per open bar. Keep
// height locked to spacing(10) or the stacked layout breaks.
// The triple-& raises specificity above AlertBanner's own variant classes
// (e.g. `.AlertBanner.topAlign`) so these overrides win regardless of style
// injection order; `top`/`z-index` stay dynamic via the style prop.
// Only the side borders + radius are stripped — the variant's top/bottom
// border (e.g. `.warning`'s alertPanel_warningBorder) must stay visible.
export const fixedAlertBar = css`
  &&& {
    position: fixed;
    left: 0;
    right: 0;
    width: 100%;
    height: ${spacing(10)};
    align-items: center;
    padding: ${spacing(3)} ${spacing(5)};
    border-left: 0;
    border-right: 0;
    border-radius: 0;
  }

  .FixedAlertBanner-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    width: 100%;
    min-width: 0;
  }

  .FixedAlertBanner-message {
    margin: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .FixedAlertBanner-messageCount {
    margin-left: ${spacing(1)};
  }

  .FixedAlertBanner-link {
    margin-left: ${spacing(5)};
    text-decoration: underline;
  }
`
